import axios from "axios";
import { getData, saveData } from "./OGN";

//ognlib.js
const userInfoUrl = `https://account.opengamingnetwork.com/api/userinfo`;
const loginTokenURL = `https://account.opengamingnetwork.com/api/user/logintoken`;
export function getUserInfo() {
  return Promise.all([
    axios.get(userInfoUrl, { withCredentials: true }),
    axios.get(loginTokenURL, { withCredentials: true })
  ])
    .then(responses => {
      const [userInfo, loginToken] = responses;
      const response = { ...userInfo.data, ...loginToken.data };
      return response;
    })
    .catch(_ => ({ username: "", id: "", token: "" }));
}

export function getUserPreferences() {
  return getData({ field: `preferences` })
    .run()
    .promise()
    .then(data => data)
    .catch(_ => ({}));
}

export function saveUserPreferences() {
  return saveData({ field: `preferences` }).run().promise();
}

const ognlib = {
  version: 1,
  test: true,
  getUserInfo: function () {
    return {
      username: "Test User",
      id: 99999999,
      site: "Development Site",
      editor: false,
      groups: ["members", "subscribers", "dicerollerPremium"],
      migrated: true,
      noads: true,
      token: "6%e_2BGJ+345lg",
      subscriber: true
    };
  }
};

export default ognlib;
